import { useState } from 'react'
import { Drawer } from 'antd'
import { useLocation, useNavigate } from 'react-router'
import { ACCOUNT_PAGE } from '../../configuration/paths'
import { getNavItems } from './navItems'
import './BottomTabBar.scss'

// role/isSysAdmin come from the parent (same source as the desktop top bar) so gating can't drift.
export const BottomTabBar = ({ role, isSysAdmin, onLogout }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const [moreOpen, setMoreOpen] = useState(false)

  const { tabs, moreRows } = getNavItems(role, isSysAdmin)

  const go = (key) => {
    if (key === '__more__') { setMoreOpen(true); return }
    navigate(key)
  }
  const isActive = (key) => key === ACCOUNT_PAGE ? pathname === key : pathname.startsWith(key)

  return (
    <>
      <nav className="rz-tabbar">
        {tabs.map(t => (
          <button key={t.key} className={`rz-tab${(t.key !== '__more__' && isActive(t.key)) ? ' on' : ''}`} onClick={() => go(t.key)}>
            <span className="g">{t.icon}</span>{t.label}
          </button>
        ))}
      </nav>
      <Drawer placement="bottom" height="auto" open={moreOpen} onClose={() => setMoreOpen(false)} title="More" className="rz-more">
        {moreRows.map(r => (
          <button key={r.key} className="rz-more-row" onClick={() => { setMoreOpen(false); navigate(r.key) }}>
            {r.label}{r.desktop && <span className="rz-tag">🖥 desktop</span>}
          </button>
        ))}
        <button className="rz-more-row out" onClick={() => { setMoreOpen(false); onLogout() }}>Log out</button>
      </Drawer>
    </>
  )
}

export default BottomTabBar
